import React, { useState, useEffect} from 'react';
import { motion } from 'framer-motion';



// import { images } from '../../constants';
import { urlFor, client } from '../../client';

import { AppWrap, MotionWrap } from '../../wrapper';

import './About.scss';

// const abouts =[
//   {title: 'Web Development', description: 'I am a skilled web developer.', imgUrl: images.about01 },
//   {title: 'Web Design', description: 'I am a competent web designer.', imgUrl: images.about02 },
//   {title: 'Front End', description: 'I am a knowledgeable in UI/UX design.', imgUrl: images.about03 },
//   {title: 'Back End', description: 'I am a back end web developer.', imgUrl: images.about04 }
// ]




const About = () => {

  const [abouts, setAbouts] = useState([]);
  
  useEffect(()=>{
    const query = '*[_type == "abouts"] | order(_updatedAt desc)';

    client.fetch(query)
      .then((data)=> setAbouts(data))
  }, []);

  return (
    
    <>
      
      <h2 className='head-text'> I have worked as...</h2>

      <div className='app__profiles' >
        {abouts.map((about, index)=> (
          <motion.div
            whileInView = {{opacity:1}}
            whileHover = {{scale: 1.1}}
            transition = {{ duration: 0.5, type: 'tween'}}
            // className = "app__profile-item"
            // style={{ width: '300px', aspectRatio: '1/1', height: '100%'}}
            key={about.title + index}
          >
          <div className='app__profile-item'>
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text' style={{marginTop: 20 }}> {about.title} </h2>
            <p className='p-text' style={{marginTop: 10 }}> {about.description} </p>
          </div>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  "app__whitebg");